// extracted by mini-css-extract-plugin
module.exports = {"popup":"style_popup__1BLH2","title":"style_title__3Ii9Z","itemsWrapper":"style_itemsWrapper__fiW8W","active":"style_active__2jLX8"};